import { MessageCircle } from 'lucide-react';

export const WhatsAppFloat = () => {
  const whatsappNumber = '+994773243031';
  const message = 'Salam! Phobia Games haqqında məlumat almaq istəyirəm.';
  
  const handleClick = () => {
    const url = `https://wa.me/${whatsappNumber.replace(/\+/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300"
      style={{ boxShadow: '0 0 20px rgba(34, 197, 94, 0.4)' }}
      data-testid="whatsapp-float-btn"
      aria-label="WhatsApp ilə əlaqə"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
    </button>
  );
};
